import { render, staticRenderFns } from "./PublicTableCopy.vue?vue&type=template&id=1c3c62a9&scoped=true&"
import script from "./PublicTableCopy.vue?vue&type=script&lang=js&"
export * from "./PublicTableCopy.vue?vue&type=script&lang=js&"
import style0 from "./PublicTableCopy.vue?vue&type=style&index=0&id=1c3c62a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c62a9",
  null
  
)

export default component.exports